<script lang="ts">
import type CategoryData from '@/ts/DataTypes/CategoryData';
import Data from '@/ts/Data';
import { defineComponent } from 'vue'
import Category from './Category.vue';
import App from '../App.vue';
import StaticVars, { ModalInfo } from '@/ts/StaticVars';
import { UserDB } from '@/ts/DexieDB';

/*
Old UI- not actively using 
*/
export default defineComponent({
    components: { Category },
    props:
    {
        //passed over after doing stuff on the entry screen
        state:String,
        SwitchScreen:{ type:Function, default:()=>{console.log("it didn't pass func correctly");}},//have to give it a default value, or typescript thinks it could be undefined...
        ShowModal:{ type:Function, default:()=>{console.log("it didn't pass ShowModal correctly");}},
        user:{type:UserDB, required:true},
    },
    data() {
        return {
        // icon:{ type:String, default:"home"},
        // text:{ type:String, default:"Go Home"}
        categories: new Array()

        };
    },

    //app doesn't like the prop object if not passing props- error without reason
    // props: {
    //     // categories: Array<CategoryData>,
    // },
    
    async mounted()
    {
        console.log("ChooseCategory mounted");

        // let value = await Data.GetCategories(this.user.id) as Array<CategoryData>;
        let value = Data.cats;
        // console.log("ChooseCategory, got data for categories: ", value);
        this.categories = value;
        // console.log("ChooseCategory finished! this.categories: ", this.categories);

        // console.log("ChooseCategory this state: ", this.state);

  },
  methods:{
    CatClicked(i:any)//cat comes in as a proxy, not the actual cat
    {
        // this.count++;
        // console.log("cat clicked: ", event, "going to entry screen!", JSON.stringify(event));
        console.log("cat clicked: "+ "going to entry screen!", this.categories, "i: ", i);
        //now switch to CatEntry Screen
        // event.name="changed!";

        //vue router won't let you send objects- only strings/ pretends like it's an actual new independent website
        // router.push({name:"entryscreen", params:{category:JSON.stringify(event)}});
        

        // this.$router.push({name:"entryscreen", params:{category:JSON.stringify(event)}});
        // this.SwitchScreen(StaticVars.SCREENS.EnterIntoCat);
        this.SwitchScreen(StaticVars.SCREENS.EnterIntoCat, {id:i/* , cat:this.categories[i] */});
    },
    NewCatClicked()
    {
        console.log("new cat clicked");
        //bring up a modal for entering the infomation
        let modal_info = new ModalInfo({text: `Enter name for category to create: `, callback_yes:this.CreateNewCat, text_input:true});
        this.ShowModal(modal_info);
        // this.ShowModal("Enter name for category to create: ", this.CreateNewCat, undefined, true);
    },
    CreateNewCat(new_cat_info:any)
    {
        console.log("new cat inf: ", new_cat_info);
    },

  },
})
</script>

<template >
    <div style="text-align:center">
        <div class="ChooseCat">
            <Category  @click="CatClicked(i)" v-for="(cat, i) in categories"  :text="cat.name"  :icon="cat.icon" :color_bg="cat.color_bg" :color_txt="cat.color_txt"/>

            <!-- Category just for adding a new category -->
            <Category  @click="NewCatClicked()"  text="" icon="add" color_bg="green" color_txt="white"/>
        </div>
    </div>
</template>

<style scoped>
.ChooseCat
{
    /* display: inline-grid; grid-template-columns: 1fr 1fr; padding: 0 2rem; margin: 0 auto; text-align:center; */
    display: flex;
    width:100%;
    flex-wrap: wrap;
}
</style>